import type {EditorView} from "prosemirror-view";
import type {ResolvedPos} from "prosemirror-model";

import {createFileUploadingPlaceholder} from "./createFileUploadingPlaceholder";
import {placeFile, uploadFileToS3} from "../../../utils/file/ImageUploadLogic";
import {getEditorFileUploadManager} from "../../background-services/editorFileUploadManager";
import {unsavedChangesManager} from "../../../stores/UnsavedChangesManager";
import { IStorageService } from "../../../platform/services/storage/StorageService";

export const uploadFileWithProgressBar = (
    view: EditorView, 
    file: File, 
    storageService: IStorageService,
    tenantId: string,
    targetPos?: number | ResolvedPos, 
    length: number = 0
) => {
    const fileNode = createFileUploadingPlaceholder(file, file.name);
    const localSrc = fileNode.attrs.src;
    let tr = placeFile(view, fileNode, targetPos, length);

    view.focus();
    view.dispatch(tr.scrollIntoView());

    // prevent user from leaving the page in process of the file upload
    unsavedChangesManager.declareUnsavedChanges()

    uploadFileToS3(file, storageService, tenantId).then(({s3FileName, mimeType}) => {
        getEditorFileUploadManager().updateViewWithOurSrc(localSrc, s3FileName);
        unsavedChangesManager.declareNoUnsavedChanges()
    });
}